import React, { useCallback, useMemo, useEffect } from 'react'
import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core'
import { Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import Accordion from '_/components/accordion'
import { KanbanCard } from '_views/kanban-service-order/components/card'

import useStyles from './styles'
import { CARD_FIELDS, CARD_MOCK } from './constants'

function mapSelectedToServiceOrder(mock, selected) {
  const result = {}
  if (selected.includes('id')) result.id = mock.id
  if (selected.includes('property_code')) result.propertyCode = mock.property_code
  if (selected.includes('created_at')) result.createdAt = mock.created_at
  if (selected.includes('priority')) result.priority = mock.priority
  if (selected.includes('phone')) result.phone = mock.phone
  if (selected.includes('category')) result.category = mock.category
  if (selected.includes('tenant_name')) result.tenantName = mock.tenant_name
  if (selected.includes('address')) result.address = mock.address
  return result
}

export function CustomizeCard() {
  const styles = useStyles()
  const { watch, setValue, getValues, register, setError, clearErrors, errors } = useFormContext()

  useEffect(() => {
    register(
      { name: 'cardFields' },
      {
        validate: value =>
          (Array.isArray(value) && value.length > 0) || 'Selecione pelo menos um campo',
      }
    )
  }, [register])

  const selectedFields = watch('cardFields') || []

  const handleToggle = useCallback(
    field => () => {
      const current = getValues('cardFields') || []
      const exists = current.includes(field)
      const next = exists ? current.filter(f => f !== field) : [...current, field]

      if (next.length === 0) {
        setError('cardFields', { type: 'manual', message: 'Selecione pelo menos um campo' })
      } else {
        clearErrors('cardFields')
      }

      setValue('cardFields', next, { shouldDirty: true })
    },
    [getValues, setValue, setError, clearErrors]
  )

  const previewServiceOrder = useMemo(
    () => mapSelectedToServiceOrder(CARD_MOCK, selectedFields),
    [selectedFields]
  )

  return (
    <Accordion id="customizeCard" title="Personalizar card" className={styles.container}>
      {errors?.cardFields?.message && (
        <Typography className={styles.errorMessage}>{errors.cardFields?.message}</Typography>
      )}
      <FormGroup className={styles.checkboxList}>
        {Object.values(CARD_FIELDS).map(field => (
          <FormControlLabel
            key={field.name}
            control={
              <Checkbox
                color="primary"
                checked={selectedFields?.includes(field.name)}
                onChange={handleToggle(field.name)}
              />
            }
            label={field.label}
          />
        ))}
      </FormGroup>

      <div className={styles.previewWrapper}>
        <KanbanCard
          serviceOrder={previewServiceOrder}
          className={styles.previewCard}
          viewOnlyMode
        />
      </div>
    </Accordion>
  )
}
